import { AutocompleteItem } from "../components/Autocomplete";

export const defaultCountry: AutocompleteItem = {
  value: "PL",
  label: "Polska",
};

export const countriesDialCodes = [
  "ad",
  "pl",
  "at",
  "ba",
  "be",
  "bg",
  "by",
  "ca",
  "cn",
  "cs",
  "cy",
  "cz",
  "de",
  "dk",
  "ee",
  "es",
  "fi",
  "fr",
  "gb",
  "gr",
  "hr",
  "hu",
  "ie",
  "is",
  "it",
  "li",
  "lt",
  "lu",
  "lv",
  "ma",
  "mc",
  "md",
  "mk",
  "nl",
  "no",
  "pa",
  "pl",
  "pt",
  "ro",
  "ru",
  "se",
  "si",
  "sk",
  "sm",
  "sz",
  "tr",
  "ua",
  "us",
  "va",
  "xk",
  "xm",
  "in",
];

export const countriesDialCodesLength: Record<string, number> = {
  ad: 3,
  at: 2,
  ba: 3,
  be: 2,
  bg: 3,
  by: 3,
  ca: 1,
  cn: 2,
  cy: 3,
  cz: 3,
  de: 2,
  dk: 2,
  ee: 3,
  es: 2,
  fi: 3,
  fr: 2,
  gb: 2,
  gr: 2,
  hr: 3,
  hu: 2,
  ie: 3,
  is: 3,
  it: 2,
  li: 3,
  lt: 3,
  lu: 3,
  lv: 3,
  ma: 3,
  mc: 3,
  md: 3,
  mk: 3,
  nl: 2,
  no: 2,
  pa: 3,
  pl: 2,
  pt: 3,
  ro: 2,
  ru: 1,
  se: 2,
  si: 3,
  sk: 3,
  sm: 3,
  sz: 3,
  tr: 2,
  ua: 3,
  us: 1,
  va: 2,
  xk: 3,
  in: 2,
};
